import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Button,
  Box,
  Typography,
  CircularProgress,
  TextField,
  styled,
  MenuItem,
  debounce,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { fetchGoalsData } from "../../../action/userOwnGoals";
import { fetchTounamentData } from "../../../action/userOwnTournament";
import { toast } from "react-toastify";
import { isArray } from "jquery";
import TournamentVideoComponent from "./TournamentVideoComponent/TournamentVideoComponent";
import GoalVideoComponent from "./GoalVideoComponents/GoalVideoComponent";
import VideoSkeleton from "../Leaderboard/VideoSkeleton";
import moment from "moment";
import { useSkipFirstRender } from "../../../hooks/useSkipFirstRender";
import CategoryComponent from "../CategoryComponent/Index";
import GoalTabSection from "./GoalVideoComponents/Index";
import GoalChallengesTabSection from "./GoalChallengesVideoComponents/Index";
import TournamentTabSection from "./TournamentVideoComponent/Index";
import GoalClubTabSection from "./ClubVideoComponent/Index";
import GoalLeagueTabSection from "./LeagueVideoComponent/Index";
import { useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";

const CustomTextarea = styled(TextField)(() => ({
  flexGrow: "1",
  justifyContent: "center",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    color: "#6f7081",
    padding: "0px 0px 0px 30px;",
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      outline: "none",
    },
  },

  "& .MuiInputBase-input": {
    padding: "0",
  },

  "& .MuiSelect-icon": {
    color: "#6f7081 !important",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const GoalVideos = () => {
  const token = useSelector((state) => state.auth.token);
  const userData = useSelector((state) => state.user);
  const myGoalsData = useSelector((state) => state.myGoals);
  const myTournamentsData = useSelector((state) => state.myTournaments);
  const [myGoals, setMyGoals] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [filter, setFilter] = useState("");
  const [filterState, setFilterState] = useState("goals");
  const globalSearchData = useSelector((state) => state.globalSearch);
  const [yearMonth, setyearMonth] = useState("default");
  const goalCategories = useSelector((state) => state.goalCategories);
  const features = useSelector((state) => state.features);
  const [subFilter, setSubFilter] = useState("");
  const [childFilter, setChildFilter] = useState("");
  const { set } = useParams();

  useEffect(() => {
    if (set) {
      setFilterState(set);
      // alert("aler t ");
      // removeParam();
    }
  }, [set]);

  const location = useLocation();
  const navigate = useNavigate();

  const removeParam = () => {
    const newPath = location.pathname.replace(/\/\d+$/, "");
    navigate(newPath, { replace: true });
  };

  return (
    <>
      <Box className="leader-board-main">
        <Box className="leader-board-wrapper">
          <Box className="heading">
            <Typography component="h1">MY ACCOUNT</Typography>
          </Box>
          <Box className="month-filter-wrapper">
            <Button
              onClick={() => {
                setFilterState("goals");
              }}
              className={filterState == "goals" ? "active filter" : "filter"}
            >
              My Goals
            </Button>

            {features.loading ? (
              <CircularProgress sx={{ color: "#ef364e" }} />
            ) : features.data?.data?.length > 0 ? (
              features.data.data
                ?.filter((fetu) => fetu.enable)
                .map((fetu, index) => (
                  <Button
                    onClick={() => {
                      // setLoading(true);
                      // setMyGoals(null);
                      setFilterState(fetu.id);
                    }}
                    className={
                      filterState == fetu.id ? "active filter" : "filter"
                    }
                  >
                    {fetu.name}
                  </Button>
                ))
            ) : null}
          </Box>

          {filterState == "goals" ? (
            <GoalTabSection filterState={"goals"} />
          ) : filterState == 2 ? (
            <TournamentTabSection filterState={2} />
          ) : filterState == 1 ? (
            <GoalChallengesTabSection filterState={1} />
          ) : filterState == 3 ? (
            <GoalClubTabSection filterState={3} />
          ) : filterState == 4 ? (
            <GoalLeagueTabSection filterState={4} />
          ) : null}
        </Box>
      </Box>
    </>
  );
};

export default GoalVideos;
